import { useEffect, useState } from "react";
import UserAccTreeSelect from "../general/form-control/user-acc-tree-select";
import ExchangeTreeSelect from "../general/form-control/exchange-tree-select";
import StockTreeSelect from "../general/form-control/stock-tree-select";


const SelectInput = ({ label,id,onValueChange }:any) => {

    const [currentStock, setCurrentStock] = useState<any>([]);
    const [inputs, setInputs] = useState<any>({});


    useEffect(() => {
       // alert(currentStock)
        onValueChange("stock",currentStock);
    }, [currentStock]);

    return (
        <>
      
            <div className="col-xxxxl-12 col-xl-12 col-lg-12 col-md-12 col-12">
                {' '}
                <div className="input-container ">
                    <div className="label">Stock Name</div>
                    <StockTreeSelect
                        filter={inputs}
                        onChange={(value: string) => {
                            // console.log('StockTreeSelect');
                            // console.log(value);
                            setCurrentStock(value);
                          //  onInputChange('stocks', value);
                        }}
                    />
                </div>
            </div>
        </>    
    );
}

export default SelectInput;